module.exports = __webpack_public_path__ + "img/Wp_2025.7da72b9e.png";